import { useTranslation } from 'react-i18next'
import type { RunStatus } from '../api/types'
import { Badge } from './ui/Card'

/**
 * Run status: the label on a soft tint of its own colour. No dot — the word carries the colour, so a
 * row of statuses stays quiet instead of turning into a row of pills with beads in them
 * (docs/web-ui.md §3).
 */
export function RunStatusBadge({ status }: { status: RunStatus }) {
  const { t } = useTranslation()
  const tone = status === 'succeeded' ? 'success' : status === 'failed' ? 'danger' : status === 'running' || status === 'waiting-approval' || status === 'queued' ? 'accent' : 'neutral'
  return <Badge tone={tone} className="px-2 font-semibold">{t(`automations.status_${status.replace('-', '_')}`)}</Badge>
}
